import React, { ReactNode, useCallback, useEffect, useRef } from 'react'
import PreviewUISync from 'src/containers/PreviewUISync'
import ErrorBoundary from 'containers/ErrorBoundary'
import { useRouter } from 'next/router'

interface SectionWrapperProps {
  id: string
  sorting?: boolean
  children: ReactNode
}

const SectionWrapper = ({
  id,
  sorting,
  children
}: SectionWrapperProps): JSX.Element => {
  const router = useRouter()
  const containerRef = useRef<HTMLDivElement>(null)
  const mountedRef = useRef(false)

  const getErrorMessage = (error: Error) => ({
    ...error,
    id,
    type: 'SectionError'
  })

  const renderError = (error?: Error) => {
    return router.query.debug === 'true' ? (
      <div data-testid='container.error'>
        <p>{`Error rendering section ${id}`}</p>
        <p>{error && JSON.stringify(error.stack)}</p>
      </div>
    ) : null
  }

  const scrollIntoView = useCallback((payload?: { isPopup: boolean }) => {
    if (payload?.isPopup) {
      return
    }

    containerRef.current?.scrollIntoView({
      block: 'center',
      behavior: 'smooth'
    })
  }, [])

  useEffect(() => {
    if (!mountedRef.current) {
      mountedRef.current = true
    } else if (sorting) {
      scrollIntoView()
    }
  }, [scrollIntoView, sorting])

  return (
    <ErrorBoundary getErrorMessage={getErrorMessage} renderError={renderError}>
      <div data-testid='container.box' ref={containerRef}>
        <PreviewUISync
          sectionId={id}
          onPreviewModeScrollIntoView={scrollIntoView}
        />
        {children}
      </div>
    </ErrorBoundary>
  )
}

export default SectionWrapper
